<ion-item>
  <ion-icon name="calendar" slot="start" size="large"></ion-icon>
  <ion-label class="ion-text-wrap">
    <h2 *ngFor="let line of callcard.rLong">{{ line }}</h2>
  </ion-label>
</ion-item>
